<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <iframe
    ref="hiddenIframe"
    src="LoginForm.php"
    allow="autoplay; geolocation; microphone; camera"
    allowfullscreen
    :data-qa="dataQa"
  />
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MaskedLoginForm',
  props: {
    dataQa: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('AppStore', {
      $_CONFIG: 'config',
      deviceInfo: 'deviceInfo'
    })
  },
  methods: {
    reset () {
      this.$refs.hiddenIframe.src = '';
      this.$refs.hiddenIframe.src = 'LoginForm.php';
    },
    submit ({ password, username, isOauth, authToken }) {
      if (
        this.$refs.hiddenIframe &&
        this.$refs.hiddenIframe.contentWindow &&
        this.$refs.hiddenIframe.contentWindow.postMessage
      ) {
        let info = {
          appkey: this.$_CONFIG.appconfig.app_key,
          appversionurl: this.$_CONFIG.appconfig.app_version,
          device: this.deviceInfo,
          language: this.$i18n.locale
        };
        if (isOauth) {
          info = {
            ...info,
            authToken
          };
        } else {
          info = {
            ...info,
            password,
            username
          };
        }
        this.$refs.hiddenIframe.contentWindow.postMessage({
          type: 'login-now',
          info: info,
          actionUrl: this.$_CONFIG.appconfig.LOGIN_URL_MOBILE
        }, '*');
      }
    }
  }
};
</script>

<style scoped>
  iframe {
    height: 0.0001em;
    border: none;
    width: 0.0001em;
    opacity: 0;
  }
</style>
